import { EntitiyDefinition, FieldDefinitions } from '../DataProvider';
import { EMode } from '../Enums/EMode.enum';

export class InputWordTemplateRelation<T extends EMode = EMode.entity> {
  /** Alias: tempFileId */
  tempFileId?: any;
  /** Alias: overwriteExistingFile */
  overwriteExistingFile?: boolean;

  __typename?: string;
}

const fields: FieldDefinitions<InputWordTemplateRelation> = {
  tempFileId: {
    alias: 'tempFileId',
  },
  overwriteExistingFile: {
    alias: 'overwriteExistingFile',
  },
  __typename: {
    alias: '__typename',
  },
};

export const inputWordTemplateRelationEntityDefinition: EntitiyDefinition<InputWordTemplateRelation> =
  {
    local: {},
    remote: {
      queryName: '',
      fragmentName: 'InputWordTemplateRelation',
      withPaginationWrapper: false,
    },
    fieldDefinitions: fields,
  };
